import { render, staticRenderFns } from "./AsociarCobroPresupuesto.vue?vue&type=template&id=555ef762&scoped=true"
import script from "./AsociarCobroPresupuesto.vue?vue&type=script&lang=js"
export * from "./AsociarCobroPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./AsociarCobroPresupuesto.vue?vue&type=style&index=0&id=555ef762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ef762",
  null
  
)

export default component.exports